<div *ngIf="!wrongRequestPersonSolcert">
  <div *ngIf="isCloudSignature && needShowImages">
    <app-alert-add-document [message]="message"></app-alert-add-document>
  </div>
  <div *ngIf="isCloudSignature && !needShowImages">
    <app-alert-add-document [message]="message1"></app-alert-add-document>
  </div>
</div>
<div class="{{hasConfigDragRubric ?  'custom-container': ''}}">
    <form [formGroup]="signatureForm" class="{{hasConfigDragRubric ? 'custom-mw-980':''}}">
        <div *ngIf="wrongRequestPerson && !loading" class="alert alert-info mt-2" role="alert">
            <i class="fa fa-exclamation-circle fa-2x custom-icon-info"></i>
            <b>
                {{messageErrorRequest | translate}}
            </b>
        </div>
        <div *ngIf="wrongRequestPersonSolcert && !wrongRequestPerson && !loading" class="alert alert-info mt-2"
             role="alert">
            <div class="row">
                <div class="col-md-0">
                    <i class="fa fa-exclamation-circle fa-2x custom-icon-info"></i>
                </div>
                <div class="col-md-10">
                    <b>
                        <div [innerHTML]="messageRequest | translate">
                        </div>
                    </b>
                </div>
            </div>
        </div>
        <div *ngIf="invalidPersonConfirmation && !loading" class="col-md-2 offset-md-10 btn-valid">
            <button
                    class="btn btn-outline-primary w-100  {{hasConfigDragRubric? 'btn-mxw': ''}}"
                    type="button"
                    (click)="generateRequestInSolcert()"
                    data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.IDENTITY-VALIDATION' | translate }}">
                <span class="fa fa-id-card" aria-hidden="true"></span>
                {{ "BUTTON.VALIDATE-DOCUMENTS" | translate }}
            </button>
        </div>
        <div class="card mt-2" *ngIf="!wrongRequestPerson && !wrongRequestDocument && !wrongRequestPersonSolcert1">
            <div class="card-header mt-auto">
                <div class="row">
                    <div class="col-md-10">
                        <h5 class="title"><i
                                class="fas fa-file-signature"></i> {{ "TITLE.SIGNATURE-DOCUMENTS" | translate }}</h5>
                    </div>
                    <div class="col-md-2 custom-button-sign-cloud" *ngIf="isCloudSignature">
                        <button
                                class="btn custom-button-contract btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                [attr.disabled]="!completeData ? '' : null"
                                type="button"
                                (click)="downloadContract()"
                                data-toggle="tooltip" data-placement="top"
                                title="{{ 'BUTTON.DOWNLOAD-AGREEMENT' | translate }}">
                            <span class="fas fa-file-download" aria-hidden="true"></span>
                            {{ "BUTTON.DOWNLOAD-AGREEMENT" | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body custom-background custom-height">
                <div *ngIf="acceptRubricPlacementChecked">
                    <app-alert-add-document
                            [message]="loadMessageHtml"></app-alert-add-document>
                </div>
                <div class="row" *ngIf="!isInvited">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}</div>
                    <div class="col font-weight-light">{{person._more.enterpriseTradeNameView}}</div>
                </div>
                <div class="row">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.FLOW" | translate }}</div>
                    <div class="col-md-8 font-weight-light">{{document._more.workflowDescription}}</div>
                    <div class="col" *ngIf="electronicSignature">
                        <button type="button"
                                class="btn btn-sm btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                [attr.disabled]="signCompleted ? '' : null"
                                (click)="signGrafic(document)">
                            <i
                                    class="fa fa-stamp"></i> {{!signCompleted ? ('BUTTON.SIGN' | translate) : ('BUTTON.SIGNED' | translate)}}
                        </button>
                    </div>
                    <div class="col" *ngIf="digitalSignature">
                        <button type="button"
                                class="btn btn-sm btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                *ngIf="!hasMultipleAttachments"
                                [attr.disabled]="signCompleted ? '' : null"
                                (click)="checkStatusOne2One()">
              <span class="fa fa-signature"
                    aria-hidden="true"></span> {{!signCompleted ? ('BUTTON.SIGN' | translate) : ('BUTTON.SIGNED' | translate)}}
                        </button>
                        <button type="button"
                                class="btn btn-sm btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                *ngIf="hasMultipleAttachments"
                                (click)="signBatchBy()"
                                [attr.disabled]="signCompleted ? '' : null">
                            <i
                                    class="fa fa-signature"></i> {{!signCompleted ? ('BUTTON.SIGN' | translate) : ('BUTTON.SIGNED' | translate)}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.SUBJECT" | translate }}</div>
                    <div class="col-md-8 font-weight-light">{{document.subject}}</div>
                    <div class="col" *ngIf="signCompleted && this.hasIdentityValidation">
                        <button type="button" class="btn btn-sm btn-block btn-outline-primary custom-button"
                                (click)="downloadDocument(document)">
                            <i class="fa fa-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.SIGNATORY-DOC-NUMBER" | translate }}</div>
                    <div class="col font-weight-light width-80">{{person.documentNumber}}</div>
                </div>
                <div class="row">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.MR-MRS" | translate }}</div>
                    <div class="col-md-8 font-weight-light">{{person.fullname | translate}}</div>
                </div>
                <div class="row">
                    <div class="row col" *ngIf="!acceptRubricPlacementChecked">
                        <div class="col-md-2 font-weight-bold">{{ "LABEL.FILE-ATTACHMENTS" | translate }}</div>
                        <div class="col-md-8 font-weight-light">
                            <a href="javascript:"
                               class="{{signCompleted ? 'disabled' : ''}} {{this.resource === resource1 ? 'font-weight-bold' : ''}}"
                               *ngFor="let resource1 of resourceList; let index=index"
                               (click)="setUrlDoc(resource1)">{{resource1.fileName}}; </a>
                        </div>
                    </div>
                    <div class="row col" *ngIf="acceptRubricPlacementChecked">
                        <div class="col-md-2 font-weight-light font-weight-bold">{{ "LABEL.FILE-ATTACHMENTS" | translate }}</div>
                        <div class="col-md-4">
                            <div class="dropdown">
                                <a class="btn btn-light dropdown-toggle min-w-100" role="button"
                                   data-toggle="dropdown" aria-expanded="false">
                                    <b class="text-primary">
                                        <span>{{cutFileName(resource.fileName)}}</span>
                                    </b>
                                </a>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item">
                                        <div class="custom-control custom-checkbox my-1 mr-sm-2">
                                            <input type="checkbox"
                                                   class="custom-control-input"
                                                   id="addRemoveAllCheckbox1"
                                                   [checked]="wasAllSelected1()"
                                                   (click)="addOrRemoveAll($event)">
                                            <label class="custom-control-label"
                                                   for="addRemoveAllCheckbox1"><b>{{ "LABEL.ALL-RUBRIC-POSITION-CONFIRM" | translate}}</b></label>
                                        </div>
                                    </a>
                                    <a *ngFor="let resource1 of resourceList; let index=index"
                                       class="dropdown-item {{wasChecked(resource1) ? 'bg-custom': ''}} cursor-pointer min-w-130 {{resource1 === resource && !confirmRubricPosition ? 'bg-gray':''}}">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox"
                                                   id="resourceCheckbox{{index}}"
                                                   name="groupRadio"
                                                   class="custom-control-input"
                                                   [value]="resource1"
                                                   [checked]="wasSelected2(resource1)"
                                                   (click)="addRemoveResource($event ,resource1)">
                                            <label class="custom-control-label" for="resourceCheckbox{{index}}"></label>
                                            <label (click)="setUrlDoc(resource1)" class="cursor-pointer">
                                                {{ cutFileName(resource1.fileName) }}
                                            </label>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                     *ngIf="!isCloseStampingAndIsNotDigitalSignature && !signCompleted && hasConfigRubric">
                    <div class="col-md-2 font-weight-bold col-form-label">{{ "LABEL.STAMPING-IMAGE" | translate }}</div>
                    <div class="col-md-2 offset-md-0 font-weight-light">
                        <label for="signaturePad" class="col-form-label">{{ "LABEL.RUBRIC" | translate }}</label>
                        <div class="custom-file">
                            <button type="button"
                                    id="signaturePad"
                                    class="btn btn-sm btn-block btn-outline-success {{hasConfigDragRubric? 'btn-mxw':''}}"
                                    (click)="signaturePad()">
                                <i class="fa fa-sync-alt"></i> {{ "BUTTON.UPDATE" | translate }}
                            </button>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <label for="signaturePad" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                        <div>
                            <img [src]="defaultRubricSrc" style="{{styleDimensionsRubric}}" alt="Rubric">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2"
                         *ngIf="(isCloudSignature || haveDocumentIntegrityToGraficSign) && needShowImages">
                        <label
                                class="col-form-label font-weight-bold">{{ "LABEL.IMAGE-OF-THE-IDENTIFICATION-DOCUMENT" | translate }} </label>
                    </div>
                    <div class="col-md-8">
                        <div class="row"
                             *ngIf="(isCloudSignature || haveDocumentIntegrityToGraficSign) && needShowImages">
                            <div class="col-md-9">
                                <label for="obverseDNI"
                                       class="col-form-label font-weight-bold">{{ "LABEL.FRONT-PART-OF-THE-IDENTIFICATION-DOCUMENT" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="image/jpeg, image/png"
                                           alife-file-to-base64
                                           id="obverseDNI"
                                           (change)="readSelectedDocumentFront($event)"
                                           (onFileChanged)="changeStatus3($event)"
                                           [class.is-invalid]="isInvalidControl('documentFrontFilename2Show')">
                                    <small *ngIf="isInvalidControl('documentFrontFilename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.SELECT-IMAGE-OF-FRONT-OF-IDENTITY-DOCUMENT" | translate }}
                                    </small>
                                    <div class="custom-file-label {{hasConfigDragRubric? 'custom-file-fixed': ''}}">
                                        <label for="obverseDNI">
                                            {{signatureForm.get('documentFrontFilename2Show').value ? signatureForm.get('documentFrontFilename2Show').value : 'MESSAGE.SELECT' | translate}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <label for="obverseDNI" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div>
                                    <img [src]="defaultDocumentFrontSrc" #rubricPic style="{{styleDimensionsRubric}}"
                                         alt="Rubric">
                                </div>
                            </div>
                        </div>
                        <div class="row"
                             *ngIf="(isCloudSignature || haveDocumentIntegrityToGraficSign) && needShowImages">
                            <div class="col-md-9">
                                <label for="backDNI"
                                       class="col-form-label font-weight-bold">{{ "LABEL.REVERSE-SIDE-OF-IDENTIFICATION-DOCUMENT" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="image/jpeg, image/png"
                                           alife-file-to-base64
                                           id="backDNI"
                                           (change)="readSelectedBackDNI($event)"
                                           (onFileChanged)="changeStatus4($event)"
                                           [class.is-invalid]="isInvalidControl('documentRearFilename2Show')">
                                    <small *ngIf="isInvalidControl('documentRearFilename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.SELECT-IMAGE-OF-BACK-OF-IDENTITY-DOCUMENT" | translate }}
                                    </small>
                                    <div class="custom-file-label {{hasConfigDragRubric? 'custom-file-fixed': ''}}">
                                        <label for="backDNI">
                                            {{signatureForm.get('documentRearFilename2Show').value ? signatureForm.get('documentRearFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <label for="backDNI" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div>
                                    <img [src]="defaultDocumentRearSrc" #rubricPic style="{{styleDimensionsRubric}}"
                                         alt="Rubric">
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="isCloudSignature  && needShowImages && needShowPowerValidityAndRucFile">
                            <div class="col-md-9">
                                <label for="file"
                                       class="col-form-label font-weight-bold">{{ "LABEL.POWER-VALIDITY" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="application/pdf"
                                           id="file"
                                           alife-file-to-base64
                                           (change)="readSelectedPWfile($event)"
                                           (onFileChanged)="changeStatus1($event)"
                                           [class.is-invalid]="isInvalidControl('filename2Show')">
                                    <small *ngIf="isInvalidControl('filename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
                                    </small>
                                    <div class="custom-file-label">
                                        <label for="file">
                                            {{signatureForm.get('filename2Show').value ? signatureForm.get('filename2Show').value : ('MESSAGE.SELECT' | translate)}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <label for="file" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div>
                                    <button type="button"
                                            [disabled]="!hasPowerValidity1"
                                            class="btn btn-outline-success"
                                            (click)="openModalPdfViewer(POWER_VALIDITY)">
                                        <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="isCloudSignature  && needShowImages && needShowPowerValidityAndRucFile">
                            <div class="col-md-9">
                                <label for="rucFile"
                                       class="col-form-label font-weight-bold">{{ "LABEL.RUC-FILE" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="application/pdf"
                                           id="rucFile"
                                           alife-file-to-base64
                                           (change)="readSelectedRFfile($event)"
                                           (onFileChanged)="changeStatus7($event)"
                                           [class.is-invalid]="isInvalidControl('rucFilename2Show')">
                                    <small *ngIf="isInvalidControl('rucFilename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
                                    </small>
                                    <div class="custom-file-label">
                                        <label for="rucFile">
                                            {{signatureForm.get('rucFilename2Show').value ? signatureForm.get('rucFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <label for="file" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div>
                                    <button type="button"
                                            [disabled]="!hasRUCFile1"
                                            class="btn btn-outline-success"
                                            (click)="openModalPdfViewer(RUC_FILE)">
                                        <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 offset-md-2 mt-2"
                         *ngIf="(isCloudSignature || haveDocumentIntegrityToGraficSign) && needShowImages">
                        <button type="button"
                                class="btn btn-sm btn-block btn-outline-success {{hasConfigDragRubric? 'btn-mxw': ''}}"
                                (click)="updateImages()" [disabled]="signCompleted">
                            <i class="fa fa-sync-alt"></i> {{ description4button | translate }}
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="isCloudSignature || haveDocumentIntegrityToGraficSign">
                    <div class="col-md-2">
                        <label class="col-form-label font-weight-bold">{{ "LABEL.VERIFICATION-CODE" | translate }}
                            : </label>
                    </div>
                    <div class="col-md-2 custom-button-sign-cloud">
                        <button
                                class="btn btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                type="button" id="btnSendOTP"
                                [attr.disabled]="signCompleted ? '' :
                                haveDocumentIntegrityToGraficSign && !signCompleted ?
                                 null:(signCompleted ? '' : !completeData ? '' : null)"
                                (click)="generateCodeOrOTP()"
                                data-toggle="tooltip" data-placement="top"
                                title="{{ 'MESSAGE.MAKE-CODE-REQUEST' | translate }}">
                            <span class="{{isCloudSignature?'fas fa-mobile-alt':'fa fa-envelope'}}"
                                  aria-hidden="true"></span>
                            {{ "BUTTON.REQUEST-CODE" | translate }}
                        </button>
                        <small class="text-green" *ngIf="isEnable4sendOTP">
                            Podrá reenviar código en {{secondLeft}}s
                        </small>
                    </div>
                    <div class="col-md-6 custom-button-sign-cloud">
                        <input type="text"
                               id="codeOTP"
                               class="form-control custom-button-input-code {{hasConfigDragRubric ? 'btn-mxw': 'mx-wd-control'}}"
                               placeholder="{{ 'MESSAGE.ENTER-CODE' | translate }}..."
                               formControlName="codeOTP"
                               [class.is-invalid]="isInvalidControl('codeOTP')"
                               [attr.disabled]="haveDocumentIntegrityToGraficSign && !signCompleted ? null:(signCompleted ? '' : !completeData ? '' : null)"
                               [(ngModel)]="codeOTP" [maxLength]="6">
                        <small *ngIf="isInvalidControl('codeOTP')"
                               class="text-danger">
                            {{ "MESSAGE.ENTER-CODE-6-DIGIT" | translate }}
                        </small>
                    </div>
                    <div class="col-md-2 custom-button-sign-cloud" *ngIf="isCloudSignature">
                        <button type="button"
                                class="btn btn-block {{signCompleted?'btn-outline-success':'btn-outline-primary'}} {{hasConfigDragRubric? 'btn-mxw': 'custom-button'}}"
                                [attr.disabled]="signCompleted ? '' : !completeData ? '' : !codeSent ? '' : null"
                                [disabled]="!codeSent"
                                (click)="verifyAcceptTermToSignCloud(document,cloudSignature)">
                            <i
                                    class="fa fa-stamp"></i> {{!signCompleted ? ("BUTTON.SIGN" | translate) : ("BUTTON.SIGNED" | translate)}}
                        </button>
                    </div>
                </div>
                <div *ngIf="isRemoteSignature">
                    <div class="row">
                        <div class="col-md-2">
                            <label for="username"><b>{{ "LABEL.USER" | translate }}:</b></label>
                            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-user"></i>
                                    </div>
                                </div>
                                <input id="username"
                                       [(ngModel)]="username"
                                       (keyup)="search($event)"
                                       (change)="onSignboxDataChanged(username)"
                                       formControlName="username"
                                       class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric ? 'custom-form-control': ''}}"
                                       placeholder="{{ 'MESSAGE.ENTER-USER' | translate }}..."
                                       autocomplete="off"
                                       list="signboxList"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('username')">
                                <datalist id="signboxList" *ngIf="uanatacasignboxdatas">
                                    <option *ngFor="let uanatacasignboxdata of this.uanatacasignboxdatas"
                                            [ngValue]="uanatacasignboxdata">
                                        {{uanatacasignboxdata.user}} - {{uanatacasignboxdata.reason}}
                                    </option>
                                </datalist>
                            </div>
                            <small *ngIf="isInvalidControl('username')"
                                   class="text-danger">
                                {{ "MESSAGE.ENTER-USER" | translate }}
                            </small>
                        </div>
                        <div class="col-md-2">
                            <label for="password"><b>{{ "LABEL.PASSWORD" | translate }}:</b></label>
                            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
                                <input [type]="viewPassword ? 'text' : 'password'"
                                       id="password"
                                       class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric ? 'custom-form-control': ''}}"
                                       placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}..."
                                       formControlName="password"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('password')"
                                       [(ngModel)]="password">
                                <div class="input-group-append">
                <span class="input-group-text">
                <i
                        class="fa {{viewPassword?'fa-eye':'fa-eye-slash'}}"
                        (click)="toggleFieldTextType(PASSWORD)"
                ></i>
              </span>
                                </div>
                            </div>
                            <div><small *ngIf="isInvalidControl('password')"
                                        class="text-danger">
                                {{ "MESSAGE.ENTER-PASSWORD" | translate }}
                            </small>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="pin"><b>Pin:</b></label>
                            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
                                <input [type]="viewPin ? 'text' : 'password'"
                                       id="pin"
                                       class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric ? 'custom-form-control': ''}}"
                                       placeholder="Ingrese pin"
                                       formControlName="pin"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('pin')"
                                       [(ngModel)]="pin">
                                <div class="input-group-append">
                <span class="input-group-text">
                <i
                        class="fa {{viewPin?'fa-eye':'fa-eye-slash'}}"
                        (click)="toggleFieldTextType(PIN)"
                ></i>
              </span>
                                </div>
                            </div>
                            <div>
                                <small *ngIf="isInvalidControl('pin')"
                                       class="text-danger">
                                    {{ "MESSAGE.ENTER-PIN" | translate }}
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="country"><b>{{ "LABEL.LOCALIZATION" | translate }}:</b></label>
                            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-globe"></i>
                                    </div>
                                </div>
                                <select class="form-control {{hasConfigDragRubric ? 'custom-form-control': ''}}"
                                        id="country"
                                        [attr.disabled]="signCompleted ? '' : null"
                                        formControlName="country"
                                        [(ngModel)]="countryIdSelected"
                                        [class.is-invalid]="isInvalidControl('country')">
                                    <option *ngFor="let country of countries"
                                            [value]="country.id"> {{country.name | translate}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="password"><b>{{ "LABEL.REASON-FOR-SIGNATURE" | translate }}:</b></label>
                            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-text-height" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <input type="text"
                                       id="reason"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric ? 'custom-form-control': ''}}"
                                       placeholder="{{ 'MESSAGE.ENTER-REASON-SIGNATURE' | translate }}"
                                       formControlName="reason"
                                       [class.is-invalid]="isInvalidControl('reason')"
                                       [(ngModel)]="reasonForSigning">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div
                                class="col-md-2 font-weight-bold custom-div-sign-remote {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">
                            {{ "LABEL.CERTIFICATE-EXPIRATION" | translate }}:
                        </div>
                        <div
                                class="col font-weight-light custom-button-sign-remote {{isCertificateDueDateCorrect(certificateDueDate)?'custom-div-certificate-ok':'custom-div-certificate-error'}} {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">{{certificateDueDate | dateformat}}</div>
                        <div class="col-md-8 custom-button-sign-remote">
                            <button
                                    class="btn {{signCompleted ? 'btn-outline-success':'btn-outline-primary'}} col-md-3 offset-md-9 {{hasConfigDragRubric? 'btn-mxw': ''}}"
                                    type="button"
                                    (click)="opensignModal(document,remoteSignature)"
                                    [attr.disabled]="signCompleted ? '' : null"
                                    data-toggle="tooltip" data-placement="top"
                                    title="{{ 'LABEL.REMOTE-SIGNATURE' | translate }}">
                                <span class="fa fa-signature" aria-hidden="true"></span>
                                {{!signCompleted ? ("BUTTON.SIGN" | translate) : ("BUTTON.SIGNED" | translate)}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isCloseStampingAndIsNotDigitalSignature && isCloudSignatureComplete">
                    <div class="col-md-2 font-weight-bold">{{ "LABEL.NOTE" | translate }}</div>
                    <div class="col-md-8 font-weight-light">
                        {{ "MESSAGE.YOU-ARE-NOT-ALLOWED-TO-UPLOAD-YOUR-SIGNATURE-BECAUSE-ALREADY-BEEN-DIGITAL-SIGNED" | translate }}
                    </div>
                </div>
                <div class="{{hasConfigDragRubric ? 'pdf-box':'' }}" *ngIf="showPdf">
                    <app-pdf-viewer *ngIf="!reloadingPdf" [urlStream]="urlStream" [rubricSrc]="defaultRubricSrc"
                                    [showRubric]="hasConfigDragRubric && this.resource.sign"
                                    [resource]="this.resource" [signComplete]="signCompleted"
                                    [signatureDescriptions]="getListSignatureDescription()"
                                    [typeSignature]="typeSignature"
                                    [personId]="personId"
                                    [isUser]="false"
                                    [isLastOperator]="isLastOperator"
                                    (rubricDragged)="rubricDragEnd($event)"
                                    [eventDragging]="eventsSubject.asObservable()">
                    </app-pdf-viewer>
                </div>
            </div>
        </div>
    </form>
</div>
<app-loading *ngIf="loading || loadingSign"></app-loading>
